export default "__VITE_ASSET__8dc510ac__"